import * as React from 'react';

import './DividerStyle.less';

export default class Divider extends React.PureComponent {
  public render() {
    return <div className="divider" />;
  }
}
